import { render, staticRenderFns } from "./FormProductPas.vue?vue&type=template&id=3ffb2079&scoped=true&"
import script from "./FormProductPas.vue?vue&type=script&lang=js&"
export * from "./FormProductPas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb2079",
  null
  
)

export default component.exports